/* bnk-recently-viewed.js — "Nemrég megtekintett termékek" a termékoldalon.
   A megtekintett termékek handle-jeit localStorage-ban tartja
   (bnk_recently_viewed_v1, max 12), és a kártyákat a bnk-rv-card szekcióval
   tölti be (/products/<handle>?section_id=bnk-rv-card), sorrendtartóan.
   A 404-es (törölt/lejárt) termékeket kigyomlálja a listából. */
(function () {
  'use strict';

  var KEY = 'bnk_recently_viewed_v1';
  var STORE_MAX = 12;

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, STORE_MAX))); } catch (e) {}
  }

  function drop(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  function init() {
    var root = document.querySelector('[data-bnk-recently-viewed]');
    if (!root || root.hasAttribute('data-rv-init')) return;
    root.setAttribute('data-rv-init', '');

    var current = root.getAttribute('data-current-handle') || '';
    var max = parseInt(root.getAttribute('data-max') || '5', 10) || 5;
    // Ajánlókból kizárt termékek (téma-beállítás: Ajánlók → Kizárt handle-ök).
    // Nem termék jellegű tételek — pl. „Logisztikai díj" — nem valók ide.
    var excluded = (root.getAttribute('data-excluded') || '')
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);

    // Megjelenítendők: a KORÁBBI lista, a mostani termék és a kizártak nélkül.
    var list = read();
    var show = list
      .filter(function (h) { return h !== current && excluded.indexOf(h) === -1; })
      .slice(0, max);

    // A mostani termék felvétele a lista elejére (dedupe).
    if (current) {
      write([current].concat(list.filter(function (h) { return h !== current; })));
    }

    if (!show.length || !window.fetch) return;

    var ul = root.querySelector('ul');
    if (!ul) return;

    var results = new Array(show.length);
    var pending = show.length;

    show.forEach(function (handle, i) {
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=bnk-rv-card')
        .then(function (r) {
          if (!r.ok) { throw r.status; }
          return r.text();
        })
        .then(function (html) {
          var t = document.createElement('template');
          t.innerHTML = html;
          results[i] = t.content.querySelector('li.grid__item');
        })
        .catch(function (status) {
          if (status === 404) drop(handle); // törölt / nem publikált termék
        })
        .then(function () {
          pending--;
          if (pending === 0) {
            // Egyszerre, eredeti sorrendben szúrjuk be, hogy ne ugráljon a rács.
            results.forEach(function (li) { if (li) ul.appendChild(li); });
            if (ul.children.length) root.hidden = false;
          }
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
